import React, { useEffect, useState } from "react";
import Layout from "../../../layout";
import Filters from "./Filters";
import { Box, Button, Flex } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import ReactDataTable from "../../../components/PrimaryTable";
import {
  fetchCountryRequest,
  fetchExistingPatientsRequest,
  fetchHealthConcernRequest,
  fetchHospitalsRequest,
} from "../ipsStore/actions";
import { IoMdDownload } from "react-icons/io";
import DataTableColumns from "../../../components/DataTableColumns";

const ExistingPatients = () => {
  const dispatch = useDispatch();

  const { existingPatientsResponse } = useSelector((state) => state.ips);

  const [stage, setStage] = useState("");
  useEffect(() => {
    let payload = { is_master: true };
    dispatch(fetchHospitalsRequest(payload));
    dispatch(fetchCountryRequest());
    dispatch(fetchHealthConcernRequest(payload));
    payload = {};
    // dispatch(fetchExistingPatientsRequest(payload));
  }, []);

  // CSV conversion function
  const convertToCSV = (columns = [], data = []) => {
    if (!columns.length || !data.length) {
      console.error("No Data available to convert to CSV");
      return null;
    }

    const headers = columns.map((col) => col.name);

    const rows = data.map((row) =>
      columns.map((col) => {
        const selector = col.selector;
        return typeof selector === "function" ? selector(row) : row[selector];
      })
    );

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map((e) => e.join(",")).join("\n");

    return csvContent;
  };

  const handleDownload = () => {
    const csvContent = convertToCSV(
      DataTableColumns(),
      existingPatientsResponse?.data
    );

    if (!csvContent) {
      alert("Failed to generate CSV. No valid data or columns.");
      return;
    }

    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "existing_patients_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleSearch = (filters) => {
    setStage(filters.stage);
    let payload = filters;
    dispatch(fetchExistingPatientsRequest(payload));
  };

  return (
    <Layout header={"Existing Patients"} iconUrl="/home">
      <Filters onSearch={handleSearch} />
      <Flex justifyContent={"end"}>
        {existingPatientsResponse?.data?.length > 0 && (
          <Button
            rightIcon={<IoMdDownload />}
            colorScheme="green"
            m={4}
            onClick={handleDownload}
          >
            Download
          </Button>
        )}
      </Flex>
      <Box
        minHeight="600px"
        bgColor={"#ffff"}
        ml="10px"
        shadow="md"
        borderWidth="1px"
        borderRadius="md"
      >
        <ReactDataTable
          columns={DataTableColumns("Existing Patients")}
          data={existingPatientsResponse?.data || []}
          screen="Existing Patients"
          stage={stage}
        />
      </Box>
    </Layout>
  );
};

export default ExistingPatients;
